var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCharge = function SvgCharge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2834_6419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.83301H14.1667C14.6087 5.83301 15.0326 6.0086 15.3452 6.32116C15.6577 6.63372 15.8333 7.05765 15.8333 7.49967V7.91634C15.8333 8.02685 15.8772 8.13283 15.9554 8.21097C16.0335 8.28911 16.1395 8.33301 16.25 8.33301C16.3605 8.33301 16.4665 8.37691 16.5446 8.45505C16.6228 8.53319 16.6667 8.63917 16.6667 8.74967V11.2497C16.6667 11.3602 16.6228 11.4662 16.5446 11.5443C16.4665 11.6224 16.3605 11.6663 16.25 11.6663C16.1395 11.6663 16.0335 11.7102 15.9554 11.7884C15.8772 11.8665 15.8333 11.9725 15.8333 12.083V12.4997C15.8333 12.9417 15.6577 13.3656 15.3452 13.6782C15.0326 13.9907 14.6087 14.1663 14.1667 14.1663H12.5",
    stroke: "#1565C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 5.83301H4.99967C4.55765 5.83301 4.13372 6.0086 3.82116 6.32116C3.5086 6.63372 3.33301 7.05765 3.33301 7.49967V12.4997C3.33301 12.9417 3.5086 13.3656 3.82116 13.6782C4.13372 13.9907 4.55765 14.1663 4.99967 14.1663H5.83301",
    stroke: "#1565C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 6.66699L8.33301 10.0003H10.833L9.16634 13.3337",
    stroke: "#1565C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2834_6419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCharge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "charge.acf2542f0811ee1740bf2a3c94f94791.svg";